(function ($) {
    "use strict";

    // ── Helpers ──────────────────────────────────────────────────────────────

    var MONTHS_PT = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
    ];
    var DAYS_PT = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

    function pad(n) {
        return n < 10 ? "0" + n : String(n);
    }

    function toYMD(y, m, d) {
        return y + "-" + pad(m + 1) + "-" + pad(d);
    }

    function daysInMonth(y, m) {
        return new Date(y, m + 1, 0).getDate();
    }
    function firstDayOfMonth(y, m) {
        var day = new Date(y, m, 1).getDay();
        return (day + 6) % 7; // Monday = 0
    }

    function formatDisplay(ymd) {
        if (!ymd) return "";
        var p = ymd.split("-");
        return pad(parseInt(p[2], 10)) + "/" + pad(parseInt(p[1], 10)) + "/" + p[0];
    }

    // Parse a fully-typed "dd/mm/aaaa" string into {y, m, d}; null if invalid.
    function parseTypedDate(str) {
        var m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(str);
        if (!m) return null;
        var d = parseInt(m[1], 10),
            mo = parseInt(m[2], 10),
            y = parseInt(m[3], 10);
        if (mo < 1 || mo > 12) return null;
        if (d < 1 || d > daysInMonth(y, mo - 1)) return null;
        return { y: y, m: mo - 1, d: d };
    }

    // Parse a partial "dd/mm/aaaa" to {y, m} once month + 4-digit year are valid,
    // so the calendar can jump to far years before the day is even typed.
    function parseMonthYear(str) {
        var p = str.split("/");
        if (p.length < 3 || p[2].length !== 4) return null;
        var mo = parseInt(p[1], 10),
            y = parseInt(p[2], 10);
        if (!(mo >= 1 && mo <= 12) || !(y >= 1)) return null;
        return { y: y, m: mo - 1 };
    }

    // Re-insert slashes as the user types digits: "01012001" → "01/01/2001".
    function autoFormatTyped(raw) {
        var digits = raw.replace(/\D/g, "").slice(0, 8);
        var out = digits.slice(0, 2);
        if (digits.length >= 3) out += "/" + digits.slice(2, 4);
        if (digits.length >= 5) out += "/" + digits.slice(4, 8);
        return out;
    }

    function syncClearBtn() {
        var has =
            $(".ni-input-pill__field").val() || $('input[name="date_from"]').val() || $('input[name="date_to"]').val();
        $(".ni-btn-clear").toggleClass("is-hidden", !has);
    }

    // ── DateRangePicker ───────────────────────────────────────────────────────

    function DateRangePicker($pillFrom, $pillTo, $inputFrom, $inputTo, $form) {
        this.$pillFrom = $pillFrom;
        this.$pillTo = $pillTo;
        this.$inputFrom = $inputFrom;
        this.$inputTo = $inputTo;
        this.$form = $form;
        this.$drp = null;

        var now = new Date();
        this.viewYear = now.getFullYear();
        this.viewMonth = now.getMonth();
        this.fromVal = $inputFrom.val() || "";
        this.toVal = $inputTo.val() || "";
        this.committedFrom = this.fromVal;
        this.committedTo = this.toVal;

        this._buildDOM();
        this._bind();
        this._updatePills();
    }

    DateRangePicker.prototype._buildDOM = function () {
        this.$drp = $(
            '<div class="ni-drp" role="dialog" aria-label="Selecionar intervalo de datas">' +
                '  <div class="ni-drp__inner">' +
                '    <div class="ni-drp__inner__edition">' +
                '      <button type="button" class="ni-drp__typed-toggle" aria-expanded="false">' +
                '        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="manual-icon">' +
                '          <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />' +
                "        </svg>" +
                "        <span>" +
                ((window.hcpNoticias && window.hcpNoticias.manualToggle) || "Edição manual") +
                "        </span>" +
                "      </button>" +
                "    </div>" +
                '    <div class="ni-drp__typed">' +
                '      <label class="ni-drp__field">' +
                '        <span class="ni-drp__field-label">De</span>' +
                '        <input type="text" class="ni-drp__typed-input" data-target="from" inputmode="numeric" maxlength="10" placeholder="dd/mm/aaaa" autocomplete="off" aria-label="Data de início" />' +
                "      </label>" +
                '      <label class="ni-drp__field">' +
                '        <span class="ni-drp__field-label">Até</span>' +
                '        <input type="text" class="ni-drp__typed-input" data-target="to" inputmode="numeric" maxlength="10" placeholder="dd/mm/aaaa" autocomplete="off" aria-label="Data de fim" />' +
                "      </label>" +
                "    </div>" +
                '    <div class="ni-drp__months">' +
                '      <div class="ni-drp__cal ni-drp__cal--left"></div>' +
                '      <div class="ni-drp__divider"></div>' +
                '      <div class="ni-drp__cal ni-drp__cal--right"></div>' +
                "    </div>" +
                '    <div class="ni-drp__footer">' +
                '      <button type="button" class="ni-drp__btn-clear">' +
                "        Limpar" +
                "      </button>" +
                '      <button type="button" class="hcp-button fill ni-drp__btn-apply">' +
                "        Aplicar" +
                "      </button>" +
                "    </div>" +
                "  </div>" +
                "</div>"
        );
        $("body").append(this.$drp);
    };

    DateRangePicker.prototype._renderMonth = function ($container, y, m, side) {
        var self = this;
        var days = daysInMonth(y, m);
        var startOffset = firstDayOfMonth(y, m);

        var h = '<div class="ni-cal">';

        // Header
        h += '<div class="ni-cal__header">';
        if (side === "left") {
            h +=
                '<button type="button" class="ni-cal__nav ni-cal__nav--prev" aria-label="Mês anterior">' +
                '<svg width="20" height="20" viewBox="0 0 24 24" fill="none">' +
                '<path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                "</button>";
        } else {
            h += '<span class="ni-cal__nav"></span>';
        }
        h += '<span class="ni-cal__month-label">' + MONTHS_PT[m] + " " + y + "</span>";
        if (side === "right") {
            h +=
                '<button type="button" class="ni-cal__nav ni-cal__nav--next" aria-label="Próximo mês">' +
                '<svg width="20" height="20" viewBox="0 0 24 24" fill="none">' +
                '<path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                "</button>";
        } else {
            h += '<span class="ni-cal__nav"></span>';
        }
        h += "</div>";

        // Day names
        h += '<div class="ni-cal__grid">';
        for (var i = 0; i < 7; i++) {
            h += '<span class="ni-cal__day-name">' + DAYS_PT[i] + "</span>";
        }

        // Empty leading cells
        for (var e = 0; e < startOffset; e++) {
            h += '<span class="ni-cal__cell ni-cal__cell--empty"></span>';
        }

        // Day cells
        var effectiveTo = self.toVal;
        for (var d = 1; d <= days; d++) {
            var dateStr = toYMD(y, m, d);
            var cls = "ni-cal__cell";
            var isFrom = dateStr === self.fromVal;
            var isTo = dateStr === self.toVal;

            if (self.fromVal && effectiveTo) {
                var lo = self.fromVal < effectiveTo ? self.fromVal : effectiveTo;
                var hi = self.fromVal < effectiveTo ? effectiveTo : self.fromVal;
                if (dateStr > lo && dateStr < hi) cls += " is-in-range";
            }

            if (isFrom || isTo) cls += " is-edge";
            if (isFrom) cls += " is-from";
            if (isTo) cls += " is-to";

            h += '<button type="button" class="' + cls + '" data-date="' + dateStr + '">' + d + "</button>";
        }

        h += "</div></div>";
        $container.html(h);
    };

    DateRangePicker.prototype._render = function () {
        var ry = this.viewYear,
            rm = this.viewMonth + 1;
        if (rm > 11) {
            rm = 0;
            ry++;
        }
        this._renderMonth(this.$drp.find(".ni-drp__cal--left"), this.viewYear, this.viewMonth, "left");
        this._renderMonth(this.$drp.find(".ni-drp__cal--right"), ry, rm, "right");
    };

    DateRangePicker.prototype._bind = function () {
        var self = this;

        // Open on pill click (prevent native date picker)
        this.$pillFrom.on("click.drp", function (e) {
            e.preventDefault();
            self._toggle();
        });
        this.$pillTo.on("click.drp", function (e) {
            e.preventDefault();
            self._toggle();
        });

        // Month navigation
        this.$drp.on("click.drp", ".ni-cal__nav--prev", function () {
            self.viewMonth--;
            if (self.viewMonth < 0) {
                self.viewMonth = 11;
                self.viewYear--;
            }
            self._render();
        });
        this.$drp.on("click.drp", ".ni-cal__nav--next", function () {
            self.viewMonth++;
            if (self.viewMonth > 11) {
                self.viewMonth = 0;
                self.viewYear++;
            }
            self._render();
        });

        // Day selection
        this.$drp.on("click.drp", ".ni-cal__cell[data-date]", function () {
            var date = $(this).data("date");
            if (!self.fromVal || (self.fromVal && self.toVal)) {
                self.fromVal = date;
                self.toVal = "";
            } else {
                if (date < self.fromVal) {
                    self.toVal = self.fromVal;
                    self.fromVal = date;
                } else if (date === self.fromVal) {
                    // same day = single day range
                    self.toVal = date;
                } else {
                    self.toVal = date;
                }
            }
            self.hoverDay = null;
            self._render();
            self._updatePills();
            self._syncTyped();
        });

        // Reveal/hide the manual typing fields
        this.$drp.on("click.drp", ".ni-drp__typed-toggle", function () {
            var open = self.$drp.find(".ni-drp__typed").toggleClass("is-open").hasClass("is-open");
            this.setAttribute("aria-expanded", open ? "true" : "false");
            if (open) {
                self.$drp.find('.ni-drp__typed-input[data-target="from"]').focus();
            }
        });

        // Manual typing → jump calendar view and select the date
        this.$drp.on("input.drp", ".ni-drp__typed-input", function () {
            var el = this;
            var target = $(el).data("target");
            var formatted = autoFormatTyped(el.value);
            el.value = formatted;

            var my = parseMonthYear(formatted);
            if (my) {
                self.viewYear = my.y;
                self.viewMonth = my.m;
            }

            var parsed = parseTypedDate(formatted);
            if (parsed) {
                var ymd = toYMD(parsed.y, parsed.m, parsed.d);
                if (target === "from") {
                    self.fromVal = ymd;
                } else {
                    self.toVal = ymd;
                }
                self.viewYear = parsed.y;
                self.viewMonth = parsed.m;
                $(el).removeClass("is-invalid");
                self._render();
                self._updatePills();
                self._syncTyped(el);
            } else {
                $(el).toggleClass("is-invalid", formatted.length === 10);
                if (my) self._render();
            }
        });

        // Enter inside a typed field applies the range
        this.$drp.on("keydown.drp", ".ni-drp__typed-input", function (e) {
            if (e.key === "Enter" || e.keyCode === 13) {
                e.preventDefault();
                self._commitAndSubmit();
            }
        });

        // Hover preview via CSS classes (no re-render to avoid infinite loop)
        this.$drp.on("mouseenter.drp", ".ni-cal__cell[data-date]", function () {
            if (!self.fromVal || self.toVal) return;
            var hovered = $(this).data("date");
            var lo = self.fromVal < hovered ? self.fromVal : hovered;
            var hi = self.fromVal < hovered ? hovered : self.fromVal;
            self.$drp.find(".ni-cal__cell[data-date]").each(function () {
                var d = $(this).data("date");
                $(this).toggleClass("is-hover-range", d > lo && d < hi);
                $(this).toggleClass("is-hover-edge", d === hovered);
            });
        });
        this.$drp.on("mouseleave.drp", ".ni-drp__months", function () {
            self.$drp.find(".ni-cal__cell").removeClass("is-hover-range is-hover-edge");
        });

        // Clear dropdown → reset committed state and reload
        this.$drp.on("click.drp", ".ni-drp__btn-clear", function () {
            self.committedFrom = "";
            self.committedTo = "";
            self.fromVal = "";
            self.toVal = "";
            self._render();
            self._close();
            self.$form.trigger("submit");
        });

        // Apply → commit + submit form
        this.$drp.on("click.drp", ".ni-drp__btn-apply", function () {
            self._commitAndSubmit();
        });

        // Prevent clicks inside the inner panel from bubbling to document.
        // Clicks on the backdrop (.ni-drp itself) DO bubble so outside handler closes.
        this.$drp.on("click.drp", ".ni-drp__inner", function (e) {
            e.stopPropagation();
        });

        // Click outside → close
        $(document).on("click.drp-outside", function (e) {
            if (!$(e.target).closest(".ni-date-pill").length) {
                self._close();
            }
        });
    };

    DateRangePicker.prototype._commitAndSubmit = function () {
        // Normalize order if the typed range is reversed
        if (this.fromVal && this.toVal && this.fromVal > this.toVal) {
            var tmp = this.fromVal;
            this.fromVal = this.toVal;
            this.toVal = tmp;
        }
        this.committedFrom = this.fromVal;
        this.committedTo = this.toVal;
        this._close();
        this.$form.trigger("submit");
    };

    // Mirror current from/to values into the typed inputs (skipping the one
    // being edited so the caret/keystrokes aren't disrupted).
    DateRangePicker.prototype._syncTyped = function (skipEl) {
        var self = this;
        this.$drp.find(".ni-drp__typed-input").each(function () {
            if (this === skipEl) return;
            var target = $(this).data("target");
            this.value = formatDisplay(target === "from" ? self.fromVal : self.toVal);
            $(this).removeClass("is-invalid");
        });
    };

    DateRangePicker.prototype._updatePills = function () {
        var from = this.fromVal,
            to = this.toVal;

        var $lf = this.$pillFrom.find(".ni-date-pill__label");
        var $lt = this.$pillTo.find(".ni-date-pill__label");

        if (from) {
            $lf.text(formatDisplay(from));
            this.$pillFrom.addClass("has-value");
        } else {
            $lf.text(this.$pillFrom.data("placeholder") || "");
            this.$pillFrom.removeClass("has-value");
        }
        if (to) {
            $lt.text(formatDisplay(to));
            this.$pillTo.addClass("has-value");
        } else {
            $lt.text(this.$pillTo.data("placeholder") || "");
            this.$pillTo.removeClass("has-value");
        }

        this.$inputFrom.val(from);
        this.$inputTo.val(to);
        syncClearBtn();
    };

    DateRangePicker.prototype._position = function () {
        var $anchor = this.$pillFrom.closest(".ni-filters__dates");
        var offset = $anchor.offset();
        var h = $anchor.outerHeight();
        var anchorR = offset.left + $anchor.outerWidth();
        var drpW = this.$drp.outerWidth();
        var winW = $(window).width();
        // Right-align to the right edge of the dates container
        var left = anchorR - drpW;
        if (left < 16) {
            left = 16;
        }
        if (left + drpW > winW - 16) {
            left = Math.max(16, winW - drpW - 16);
        }
        this.$drp.css({ top: offset.top + h + 8, left: left });
    };

    DateRangePicker.prototype._toggle = function () {
        if (this.$drp.hasClass("is-open")) {
            this._close();
        } else {
            this._open();
        }
    };

    DateRangePicker.prototype._isMobile = function () {
        return window.matchMedia("(max-width: 680px)").matches;
    };

    DateRangePicker.prototype._open = function () {
        // Reset picker to last committed state before showing
        this.fromVal = this.committedFrom;
        this.toVal = this.committedTo;
        this._render();
        this._syncTyped();
        this.$drp.addClass("is-open");
        if (this._isMobile()) {
            this.$drp.css({ top: "", left: "" });
        } else {
            this._position();
        }
        this._prevBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    };

    DateRangePicker.prototype._close = function () {
        // Revert any in-progress selection back to committed state
        this.fromVal = this.committedFrom;
        this.toVal = this.committedTo;
        this._updatePills();
        this.$drp.removeClass("is-open");
        document.body.style.overflow = this._prevBodyOverflow || "";
    };

    // ── Init ────────────────────────────────────────────────────────────────

    $(document).ready(function () {
        var $pills = $(".ni-date-pill");
        if ($pills.length >= 2) {
            new DateRangePicker(
                $pills.eq(0),
                $pills.eq(1),
                $('input[name="date_from"]'),
                $('input[name="date_to"]'),
                $(".ni-filters__form")
            );
        }
        // Main clear button → navigate to clean URL (no filter params)
        $(document).on("click", ".ni-btn-clear", function () {
            var action = $(".ni-filters__form").attr("action");
            window.location.href = action || window.location.pathname;
        });

        syncClearBtn();
    });
})(jQuery);
